import { ReactNode, Suspense, useEffect, useState } from 'react';
import { Loader } from '../Components';
import { useMicrospecDynamicUIContext } from '../GlobalProvider';
import { useSearchParams } from 'react-router-dom';

interface PageRendererProps {
    children: ReactNode;
    prePageLoad?: (cloudProvider: any) => Promise<void>;
}

const PageRenderer = ({ children, prePageLoad }: PageRendererProps) => {
    const { cloudProvider } = useMicrospecDynamicUIContext();
    const [loading, setLoading] = useState<boolean>(true);
    const [searchParams, setSearchParams] = useSearchParams();
    const refreshParam = searchParams.get('msc-refresh');
    if (refreshParam === 'true') {
        searchParams.delete('msc-refresh');
        setSearchParams(searchParams);
        window.location.reload();
    }

    useEffect(() => {
        const executePrePageLoad = async () => {
            if (prePageLoad) {
                try {
                    await prePageLoad(cloudProvider);
                } catch (error) {
                    console.error('Error during prePageLoad execution:', error);
                }
            }
            setLoading(false);
        };
        executePrePageLoad();
    }, [prePageLoad, cloudProvider]);

    if (loading) {
        return <Loader />;
    }

    return (
        <Suspense fallback={<Loader />}>
            {children}
        </Suspense>
    );
};

export default PageRenderer;